module.exports = __webpack_public_path__ + "img/aq.f929ba71.svg";